const Table = {
  variants: {
    simple: {
      marginLeft: 0,
      tr: {
        td: {
          border: "none",
          paddingLeft: "0",
        },
        th: {
          border: "none",
          paddingLeft: "0",
        },
      },
    },
  },
};

export default Table;
